import {csvToArray} from '@netx/core-next/utils/array';
import {attributesStore} from '@netx/core-attribute/store/attributesStore';
import {ATTRIBUTE_MULTIPLE_VALUE_TYPES} from '@netx/core-attribute/constants';
import type {SearchCriteriaRaw} from '../types';
import {SearchType} from '../rules/constants';
import type {SearchRule} from '../rules/types';
import {getRuleObjectFromRawCriteria} from '../rules/getRuleObjectFromRawCriteria';

export type SavedSearchCriteriaToRuleObjectsParams = {
	criteria: SearchCriteriaRaw[];
};

const getNormalizedMultivalue = (value?: string) =>
	value == null || value === ''
		? []
		: value.match(/^".*",.*"$/)
		? csvToArray(value)
		: Array.isArray(value)
		? value
		: [value];

export const savedSearchCriteriaToRuleObjects = ({
	criteria,
}: SavedSearchCriteriaToRuleObjectsParams) => {
	const ruleObjects: SearchRule[] = [];

	const addRuleObject = (item: typeof criteria[number]) => {
		const ruleObject = getRuleObjectFromRawCriteria(item);
		ruleObject && ruleObjects.push(ruleObject);
	};

	const getMatchingAttributeSiblings = (
		item: typeof criteria[number],
		startIndex: number,
	) => {
		const items: typeof criteria = [];
		for (let i = startIndex, c = criteria.length; i < c; i++) {
			const _item = criteria[i];
			if (
				_item.type !== item.type ||
				// name does not match
				_item.value2 !== item.value2 ||
				_item.subtype1 !== item.subtype1 ||
				_item.subtype2 !== item.subtype2
			)
				break;
			items.push(_item);
		}
		return items;
	};

	for (let i = 0, c = criteria.length; i < c; i++) {
		const item = criteria[i];
		// attribute search rule
		if (item.type === SearchType.METADATA) {
			const attr = attributesStore.getAttributeByName(item.value2);
			// we know the attribute is capable of multiple values (multiselect, tag, etc)
			if (attr && ATTRIBUTE_MULTIPLE_VALUE_TYPES.includes(attr.type)) {
				const value1 = getNormalizedMultivalue(item.value1) as any;
				// find matching siblings
				const matchingAttributeSiblings = getMatchingAttributeSiblings(
					item,
					i + 1,
				);
				addRuleObject({
					...item,
					value1: value1
						.concat(
							matchingAttributeSiblings.map((item) =>
								getNormalizedMultivalue(item.value1),
							),
						)
						.flat() as any,
				});
				// skip over items that matched our attribute
				i = i + matchingAttributeSiblings.length;
				continue;
			}
		}

		// just add as is
		addRuleObject(item);
	}

	return ruleObjects;
};

export default savedSearchCriteriaToRuleObjects;
